module.exports = __webpack_public_path__ + "static/img/logowl.5e70b4e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logowl.png
// module id = HkSS
// module chunks = 155